import type { ComponentProps } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'components/banff-ui/cn';

const spinnerVariants = cva('animate-spin', {
  defaultVariants: {
    size: 'default',
  },
  variants: {
    size: {
      default: 'size-4',
      lg: 'size-6',
      sm: 'size-3',
      xl: 'size-8',
    },
  },
});

export interface SpinnerProps
  extends
    Omit<ComponentProps<'svg'>, 'size'>,
    VariantProps<typeof spinnerVariants> {}

/**
 * Indeterminate progress mark. Use on its own, or inside `Button` and `Badge`, while work is in flight.
 */
export function Spinner({
  className,
  size = 'default',
  ...props
}: SpinnerProps) {
  return (
    <svg
      aria-label="Loading"
      data-slot="spinner"
      fill="none"
      role="status"
      viewBox="0 0 24 24"
      {...props}
      className={cn(spinnerVariants({ size }), className)}
    >
      <circle
        cx="12"
        cy="12"
        opacity="0.25"
        r="9"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="3"
      />
    </svg>
  );
}
